import LegalLayout from "../components/LegalLayout";
import { PHONE_DISPLAY } from "../config";

const H = ({ children }) => (
  <h2 className="font-serif text-2xl md:text-3xl text-ciruela mt-10 mb-2">{children}</h2>
);

export default function AvisoLegal() {
  return (
    <LegalLayout title="Aviso legal" updated="Junio 2026">
      <p>
        El presente aviso legal regula el uso del sitio web de <strong>Lorena Cotano</strong> (en
        adelante, "el Sitio Web"), cuya finalidad es informar sobre los servicios de acompañamiento
        como matrona y sexóloga durante el embarazo, parto, puerperio y menopausia.
      </p>

      <H>1. Titular del sitio web</H>
      <p>
        Titular: Lorena Cotano — Matrona y Sexóloga.<br />
        Actividad: acompañamiento y asesoramiento a mujeres en sus procesos vitales.<br />
        Localidad: Montserrat (Valencia), España.<br />
        Teléfono de contacto: {PHONE_DISPLAY}.
      </p>

      <H>2. Objeto</H>
      <p>
        El Sitio Web tiene carácter informativo y divulgativo. La información publicada no sustituye en
        ningún caso el consejo, diagnóstico o tratamiento de un profesional sanitario realizado de forma
        presencial y personalizada.
      </p>

      <H>3. Condiciones de uso</H>
      <p>
        El usuario se compromete a hacer un uso adecuado y lícito del Sitio Web y de sus contenidos,
        absteniéndose de utilizarlos con fines ilícitos o que puedan dañar los derechos o intereses de
        terceros, o que de cualquier forma puedan perjudicar el normal funcionamiento del Sitio Web.
      </p>

      <H>4. Propiedad intelectual e industrial</H>
      <p>
        Todos los contenidos del Sitio Web (textos, imágenes, diseño gráfico, logotipos, marca y código)
        son titularidad de Lorena Cotano o de terceros que han autorizado su uso, y están protegidos por
        la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución
        o transformación sin autorización expresa.
      </p>

      <H>5. Responsabilidad</H>
      <p>
        Lorena Cotano no se hace responsable del mal uso que se realice de los contenidos del Sitio Web,
        siendo responsabilidad exclusiva de la persona que accede a ellos o los utiliza. Tampoco asume
        responsabilidad por la información contenida en páginas web de terceros a las que se pueda acceder
        mediante enlaces.
      </p>

      <H>6. Enlaces a terceros</H>
      <p>
        El Sitio Web puede contener enlaces a perfiles de redes sociales (Instagram) y a la futura
        aplicación móvil MATRUM. Lorena Cotano no se responsabiliza de los contenidos ni de las políticas
        de privacidad de dichas plataformas externas.
      </p>

      <H>7. Legislación aplicable</H>
      <p>
        El presente aviso legal se rige por la legislación española. Para la resolución de cualquier
        controversia, las partes se someten a los juzgados y tribunales que correspondan conforme a
        derecho.
      </p>
    </LegalLayout>
  );
}
